export const CALLBACK_FORM_NAME: string = 'jurist-callback';

export const CALLBACK_FORM_DEFAULT_TITLE: string = 'Задайте вопрос специалисту бесплатно';
